import { LoadingSpinner, TableCellId } from "@bluefalcon/components-package";
import { Organization, OrganizationCreateRequest, OrganizationUpdateRequest } from "@bluefalcon/users-management-client-fetch";
import { Box, Button, Flex, Input, Table, TableCaption, Tbody, Td, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { organizationService } from "../../services";
import { AddEditOrganizationModal } from "../../modals/add-edit-organization.modal";
import { Link } from "react-router-dom";

type OrganizationsTableProps = {};

export const OrganizationsTable = ({ }: OrganizationsTableProps) => {

    const [organization, setOrganizations] = useState<Organization[]>([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedOrganization, setSelectedOrganization] = useState<Organization>();
    const [query, setQuery] = useState('');

    const fetchOrganizations = async () => {
        setIsLoading(true);
        try {
            const { results, total: _total } = await organizationService.searchOrganizations({
                query,
            });
            setOrganizations(results);
            setTotal(_total);
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    };

    const onCreateOrganization = async (data: OrganizationCreateRequest) => {
        await organizationService.createOrganization(data);
        fetchOrganizations();
        onClose();
    };

    const onUpdateOrganization = async (id: string, data: OrganizationUpdateRequest) => {
        await organizationService.updateOrganizationById(id, data);
        fetchOrganizations();
        onClose();
    };

    const onAddButtonClick = () => {
        setSelectedOrganization(undefined);
        onOpen();
    };

    const handleEditButtonClick = (organization: Organization) => {
        setSelectedOrganization(organization);
        onOpen();
    };

    const search = async () => {
        await fetchOrganizations();
    };

    useEffect(() => {
        fetchOrganizations();
    }, []);

    if (isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>
            <Flex mb={2}>
                <form onSubmit={search}>
                    <Flex>
                        <Input onChange={(e) => setQuery(e.target.value)} value={query} placeholder="search..." type={'search'} />
                        <Button type="submit" onClick={search} ml={2} colorScheme="primary">Search</Button>
                    </Flex>
                </form>
                <Button onClick={onAddButtonClick} ml={'auto'} colorScheme="teal">Add Organization</Button>
            </Flex>
            {organization.length ? <Table variant="simple">
                <TableCaption textAlign={'left'}>Total Organizations: {total}</TableCaption>
                <Thead>
                    <Tr>
                        <Th>ID</Th>
                        <Th>Name</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {organization.map(organization => (
                        <Tr key={organization.id}>
                            <Td><TableCellId label={organization.id} route={`/organization/${organization.id}`} /></Td>
                            <Td>{organization.name}</Td>
                            <Td>
                                <Flex>
                                    <Button mr={2} size="sm" onClick={() => handleEditButtonClick(organization)}>
                                        Edit
                                    </Button>
                                    <Button as={Link} to={`/organizations/${organization.id}`} mr={2} size="sm">
                                        Details
                                    </Button>
                                </Flex>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table> : <Box textAlign={'center'} mt={5}>
                No Organizations Found.
            </Box>}
            <AddEditOrganizationModal
                onClose={onClose}
                isOpen={isOpen}
                organization={selectedOrganization}
                handleAddOrganization={onCreateOrganization}
                handleEditOrganization={onUpdateOrganization}
            />
        </>
    )
};
